import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../Webservices/api';

export const fetchBranches = createAsyncThunk(
  'branches/fetchBranches',
  async () => {
    const response = await api.get(`/branches`);
    return response.data;
  }
);

export const createBranch = createAsyncThunk(
  'branches/createBranch',
  async (branchData) => {
    const response = await api.post(`/branches`, branchData);
    return response.data;
  }
);

export const updateBranch = createAsyncThunk(
  'branches/updateBranch',
  async ({ id, data }) => {
    const response = await api.put(`/branches/${id}`, data);
    return response.data;
  }
);

export const deleteBranch = createAsyncThunk(
  'branches/deleteBranch',
  async (id) => {
    await api.delete(`/branches/${id}`);
    return id;
  }
);

const branchSlice = createSlice({
  name: 'branches',
  initialState: {
    branches: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.loading = false;
        state.branches = action.payload;
      })
      .addCase(fetchBranches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createBranch.fulfilled, (state, action) => {
        state.branches.push(action.payload);
      })
      .addCase(updateBranch.fulfilled, (state, action) => {
        const index = state.branches.findIndex(branch => branch.branch_id === action.payload.branch_id);
        if (index !== -1) {
          state.branches[index] = action.payload;
        }
      })
      .addCase(deleteBranch.fulfilled, (state, action) => {
        state.branches = state.branches.filter(branch => branch.branch_id !== action.payload);
      });
  },
});

export default branchSlice.reducer;